import React, { useState } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Button, Form } from "semantic-ui-react";
import { bindActionCreators, Dispatch } from "redux";

import { ALL_REQUESTED_PERMISSIONS, LEGIT_SERVICE_CONFIG } from "common";
import { legit } from "apex-legit-service";
import messages from "./messages";
import styles from "./styles.module.scss";
import { RootState } from "StoreTypes";
import { loginType as loginTypeSelector } from "services/legit/loginType";

export interface State extends Record<string, string> {}

export interface Props {
  legacyLogin: (params: State) => void;
  loginType: any;
}

const ApexLogin = ({ legacyLogin }: Props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  function handleLegacyLogin() {
    legacyLogin({ username: username, password: password });
  }

  const legacyForm = (
    <>
      <Form className={styles.title} onSubmit={handleLegacyLogin}>
        <Form.Input
          value={username}
          id="username"
          label={<FormattedMessage {...messages.username} />}
          onChange={(e) => setUsername(e.currentTarget.value)}
        />
        <Form.Input
          label={<FormattedMessage {...messages.password} />}
          id="password"
          onChange={(e) => setPassword(e.currentTarget.value)}
          type="password"
        />
        <Button type="submit" id="login">
          <FormattedMessage {...messages.submit} />
        </Button>
      </Form>
    </>
  );

  return (
    <>
      <div className={styles.loginPanel}>{legacyForm}</div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  isSessionLoading: legit.selectors.isSessionLoading(state),
  loginType: loginTypeSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      legacyLogin: (params) =>
        legit.login(LEGIT_SERVICE_CONFIG, {
          apexUser: true,
          ...params,
          permissions: ALL_REQUESTED_PERMISSIONS,
        }),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApexLogin);
